// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Exrr","controls":"styles_controls__1GyqY","charLimit":"styles_charLimit__3FKft","input":"styles_input__UQ4rw","send":"styles_send__2Ah-p"};